module.exports = __webpack_public_path__ + "static/media/mini_logo_light.5b539be5.svg";